const LastTime = () => (
    <section id="last-time">
        <div className="container-fluid pt-4 pb-4 text-center">
            <div className="row align-items-center justify-content-center">
                <div className="col-md-8 col-11">
                    <h3 className="mb-5"><b>Why We’re Offering This — One Last Time</b></h3>
                    <p className="mb-3"><span className="fw-light">Each batch of GlucoGen 17 is crafted using a </span><b>unique, time-sensitive fermentation process.</b></p>
                    <p className="mb-3 fw-light">This means production is slow and limited. On purpose.</p>
                    <h3 className="mb-3 text-uppercase"><span className="fw-light">Once we sell out, it can take </span><b>months</b><span className="fw-light"> to replenish our stock.</span></h3>
                    <p>
                        <span className="fw-light">So if you plan to keep going (and we hope you do)… </span><br />
                        <span className="fw-light">You’ll want to </span><b>secure your extra bottles now</b><span className="fw-light">, at a better price than you’ll ever find again.</span>
                    </p>
                </div>
            </div>
        </div>
    </section>
);

export default LastTime;